// extracted by mini-css-extract-plugin
export default {"background-wrapper":"hero-frame-module--background-wrapper--b7eca","backgroundWrapper":"hero-frame-module--background-wrapper--b7eca"};